'use client';

import Fade from '@mui/material/Fade';
import { Box, Stack } from '@/primitives';
import { LAYOUT_VARIANT } from '@/configs/layout';
import {
  buildSocietySearchHref,
  type SearchType,
} from '@/lib/publicSearchPaths';
import SocietySearchHeaderTabRow from './SocietySearchHeaderTabRow';
import { useSocietySearchTabsModel } from './useSocietySearchTabsModel';
import { SocietySearchHeaderTabsLoading } from './SocietySearchHeaderTabsLoading';

/**
 * Search-type tabs for the site AppBar center (md+). Society logo is beside BreedLOGIC in Navigation.
 */
export default function SocietySearchHeaderCenterDesktop() {
  const {
    tabs,
    tabValue,
    handleTabChange,
    pathname,
    society,
    societyHeaderTabsLoading,
  } = useSocietySearchTabsModel();

  /** Only remount fade when the tab *set* changes, not when loading flips with the same defaults. */
  const tabsTransitionKey = tabs.map((t) => t.value).join('|');

  if (societyHeaderTabsLoading) {
    return (
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          flex: 1,
          minWidth: 0,
          minHeight: '36px',
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0, width: '100%' }}>
          <SocietySearchHeaderTabsLoading variant={LAYOUT_VARIANT.DESKTOP} />
        </Box>
      </Stack>
    );
  }

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        flex: 1,
        minWidth: 0,
        height: '36px',
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0, width: '100%' }}>
        <Fade
          key={tabsTransitionKey}
          in
          timeout={180}
          style={{ width: '100%', display: 'block' }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              minHeight: 36,
              width: '100%',
              minWidth: 0,
              maxWidth: '100%',
            }}
          >
            <SocietySearchHeaderTabRow
              getHref={(tv) =>
                buildSocietySearchHref(
                  pathname.split('/')[1] || society.societyCode || '',
                  tv as SearchType,
                  null,
                )
              }
              tabButtonProps={{
                sx: {
                  borderRadius: '4px',
                  padding: '6px 16px',
                  backgroundColor: 'transparent',
                  ':hover': {
                    backgroundColor: 'action.hover',
                  },
                  '&.selectedTab': {
                    color: 'primary.main',
                    '& .MuiTypography-root': {
                      fontWeight: 700,
                    },
                  },
                  '& .MuiTypography-root': {
                    fontWeight: 600,
                    fontSize: '12px',
                    color: 'inherit',
                  },
                },
              }}
              tabs={tabs}
              value={tabValue}
              onClick={(value) => handleTabChange(value as string)}
            />
          </Box>
        </Fade>
      </Box>
    </Stack>
  );
}
